import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggingService } from '../services/logging.service';

@Injectable()
export class TelemetryInterceptor implements HttpInterceptor {

  constructor(private logger: LoggingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const startTime = Date.now();

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        this.logger.logEvent('HTTP_ERROR', {
          url: req.url,
          method: req.method,
          status: error.status,
          duration: Date.now() - startTime
        });

        return throwError(() => error);
      })
    );
  }
}
